import React from "react";
import { Gauge, MessageCircleQuestion, MessagesSquare } from "lucide-react";
import Dots from "./Dots";
import TypingPicture from "../../assets/typing.png";

const WhatandHowSection = () => {
  return (
    <div className="flex flex-col items-center w-full px-12 bg-customSlate-300">
      <div className="flex">
        <div className="px-10 py-6 -translate-y-1/4 ml-12 border-2 flex flex-col gap-2.5 w-[480px] rounded-md h-fit text-sm text-customText-800 border-customSlate-700/25 bg-customSlate-600/25">
          <div>
            <span className="text-lg font-bold text-customText-900">
              WHAT IS ELECTRIC COOP?
            </span>
            <div className="h-1 w-[50%] mt-0.5 bg-customGreen-500 rounded-full" />
          </div>
          <p>
            An electric cooperative (EC) is a type of distribution utility
            organized as a non-stock, non-profit membership corporation under
            the laws of the Philippines. The primary purpose of an electric
            cooperative is to provide and promote the utilization of electricity
            to its member-consumers on an area coverage basis, ensuring access
            to affordable and reliable electric service.
          </p>
          <p className="my-4">
            Electric cooperatives operate by employing principles of
            cooperation, allowing members to have a say in their governance and
            management, which reflects the community's needs and interests.
          </p>
        </div>
        <div className="px-12 pt-6">
          <h3 className="text-lg font-bold text-customText-900">
            HOW IT WORKS?
          </h3>
          <div className="flex gap-6 py-2">
            <img
              src={TypingPicture}
              alt=""
              className=""
            />
            <div className="flex flex-col gap-1.5 justify-center">
              <div className="flex items-center gap-2 text-customGreen-700">
                <MessagesSquare className="size-6" />
                <span className="text-base font-semibold">
                  Start a Conversation
                </span>
              </div>
              <span className="text-sm">
                Press the chat icon to open the chat window. You’ll be greeted
                with a friendly message inviting you to ask questions.
              </span>
            </div>
          </div>
          <div className="flex gap-6 py-2">
            <div className="flex flex-col items-end gap-1.5 justify-center">
              <div className="flex items-center gap-2 text-customGreen-700">
                <MessageCircleQuestion className="size-6" />
                <span className="text-base font-semibold">Ask Questions</span>
              </div>
              <span className="text-sm text-end">
                Press the chat icon to open the chat window. You’ll be greeted
                with a friendly message inviting you to ask questions.
              </span>
            </div>
            <img
              src={TypingPicture}
              alt=""
              className=""
            />
          </div>
          <div className="flex gap-6 py-2">
            <img
              src={TypingPicture}
              alt=""
              className=""
            />
            <div className="flex flex-col gap-1.5 justify-center">
              <div className="flex items-center gap-2 text-customGreen-700">
                <Gauge className="size-6" />
                <span className="text-base font-semibold">
                  Receive Instant Responses
                </span>
              </div>
              <span className="text-sm">
                Press the chat icon to open the chat window. You’ll be greeted
                with a friendly message inviting you to ask questions.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="relative w-[70%] h-[480px] bg-customSlate-500 font-bold py-6 px-8 rounded-md my-20">
        Electric Cooperative Video Demonstration / Presentation
        <Dots classname="absolute top-0 right-0 translate-x-1/3 -translate-y-1/3" />
        <Dots classname="absolute bottom-0 left-0 -rotate-180 -translate-x-1/3 translate-y-1/3" />
      </div>
    </div>
  );
};

export default WhatandHowSection;
